import request from '@api/request'

// 企业端-分页列表显示汇编
export const listAssemblyData = params => request.get('/entPolicyAssembly/listAssemblyData', { params })

// 获取汇编详情通过id
export const getAssemblyById = params => request.get('/entPolicyAssembly/getAssemblyById', { params })

